<template>
  <div :class="$style.box">
    <div
      v-for="(item, index) in circleList"
      :key="item.id"
      :class="$style.list"
      :style="{ marginRight: `${Number.isInteger((index + 1) / 4) ? 0 : 13}px` }"
      @click="handleLinkTo(item.id)"
    >
      <img :src="item.images" alt="游戏圈icon" />
      <div v-html="item.name"></div>
    </div>
  </div>
</template>

<script>
import { reportData } from '@/api/report';
export default {
  props: {
    plateId: {
      type: [Number, String],
      default: ''
    },
    circleList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    // 跳转游戏圈
    async handleLinkTo(id) {
      try {
        const r = await reportData({
          type: 1,
          data_type: 3, // 游戏圈板块-具体圈子
          game_circle_plate_id: this.plateId,
          circle_id: id
        })
      } catch (error) {
        console.log(error);
      }
      this.$router.push({ name: "gameCircle.home", query: { circleId: parseInt(id) } });
    }
  },
}
</script>

<style lang='scss' module>
.box {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  width: 100%;
  min-height: 57px;
  .list {
    display: inline-block;
    margin-bottom: 17px;
    width: 75px;
    & > img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 7px;
      width: 57px;
      height: 57px;
      flex: none;
      border-radius: 12px;
    }
    & > div {
      height: 13px;
      text-align: center;
      font-size: 10px;
      line-height: 13px;
    }
  }
}
</style>
